<script setup>
import { onMounted, ref, getCurrentInstance } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import {
    mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiBook, mdiSchool, mdiBookOpenVariant, mdiGoogleClassroom, mdiAndroidStudio,
    mdiDna, mdiCalendarArrowRight, mdiNumeric1BoxOutline, mdiNumeric2BoxOutline, mdiNumeric3BoxOutline, mdiNumeric4BoxOutline, mdiSchoolOutline, mdiAccountGroup, mdiPlusCircle, mdiPlus, mdiPlusThick, mdiCloseThick
} from "@mdi/js";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import CardBoxComponentLoad from '@/Components/CardBoxComponentLoad.vue'
import BaseButton from "@/Components/BaseButton.vue";
import { Icon } from '@iconify/vue';
import PremiumTabs from '@/Components/PremiumTabs.vue';
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { computed } from 'vue';

const props = defineProps({
    titleup: String,
    classrooms: Object,
    classroomsTutor: Object,
    classroomsCoord: Object,
    events: Array,
    eventsnow: Array,
    isAdmin: Boolean,
    isCoord: Boolean,
    isTutor: Boolean,
    isPsico: Boolean,
    isSecre: Boolean,
    coursesComp: Array,
    massDeleteResource: Boolean
});

const getCoursesForLevel = (id_level) => {
    if (!props.coursesComp) return [];
    return props.coursesComp.filter(item => item.id_level == id_level);
};

const msg1 = ref('')
const navigatorVersion = ref('')
const navigatorName = ref('')

onMounted(() => {
    listarPostit()
    navigatorVersion.value = navigator.appVersion
    navigatorName.value = navigator.appName
});

// Info de calendar
const selectedEvent = ref({})
const showDialog = ref(false)

const onEventClick = (event, e) => {
    selectedEvent.value = event
    showDialog.value = true
    e.stopPropagation()
}

const tab = ref(0)
const action = ref('edit')
const anioSearch = ref(null)

const instance = getCurrentInstance(); // Recuperar valores globales
const configGlobal = instance.appContext.config.globalProperties.confGlobal; // <-- Aqui se usa configGlobal en el template es confGlobal

const tabsMenu = computed(() => [
    { id: 0, label: 'Aula virtual', icon: 'tabler:chalkboard', show: true },
    { id: 1, label: 'Diario de asistencia', icon: 'tabler:calendar-check', show: !props.isPsico },
    { id: 2, label: 'Calificaciones', icon: 'tabler:award', show: !props.isPsico },
    { id: 3, label: 'Puntajes EAP', icon: 'tabler:certificate', show: configGlobal.value.ACADEMICO_USE_SIMULACRO_ADMISION == 1 && (props.isAdmin || props.isCoord || props.isSecre) },
    { id: 4, label: 'Recursos de estudio', icon: 'tabler:folder', show: !props.isPsico },
    { id: 5, label: 'Informes de evolución', icon: 'tabler:report-analytics', show: props.isPsico || props.isAdmin || props.isCoord },
]);

const handleTabChange = (t) => {
    if (t.id === 0) action.value = 'edit';
    if (t.id === 1) listarDiario();
    if (t.id === 2) listarCalification();
    if (t.id === 3) listarAdmisionPuntaje();
    if (t.id === 4) listarFileResources();
    if (t.id === 5) listarInformesEvo();
};

// Sección diario de asistencia
const arrayDiario = ref([]);
const arrayDiarioCol = ref([]);
const listarDiario = () => {
    let url = '/diario';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDiario.value = respuesta.diarios;
        arrayDiarioCol.value = respuesta.columnas;
    }).catch(function (error) {
        console.log(error);
    });
}

// Sección califaciones
const arrayCalification = ref([]);
const arrayCalificationCol = ref([]);
const arrayCalificationCourses = ref([]);
const listarCalification = () => {
    let url = '/calification';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayCalification.value = respuesta.datalist;
        arrayCalificationCol.value = respuesta.columnas;
        arrayCalificationCourses.value = respuesta.select1;
    }).catch(function (error) {
        console.log(error);
    });
}

// Sección Admisión puntajes
const arrayAdmisionPuntaje = ref([]);
const arrayAdmisionPuntajeCol = ref([]);
const listarAdmisionPuntaje = () => {
    let url = '/admisionpuntaje';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayAdmisionPuntaje.value = respuesta.datalist;
        arrayAdmisionPuntajeCol.value = respuesta.columnas;
    }).catch(function (error) {
        console.log(error);
    });
}

// Sección Subir archivos de forma general
const arrayFileResources = ref([]);
const arrayFileResourcesCol = ref([]);
const listarFileResources = () => {
    let url = '/document/file_resource?anioSearch=' + anioSearch.value;
    axios.get(url).then((response) => {
        let respuesta = response.data;
        arrayFileResources.value = respuesta.datalist;
        arrayFileResourcesCol.value = respuesta.columnas;
    }).catch((error) => {
        console.log(error);
    });
}

// Sección Subir archivos de forma general
const arrayInformesEvo = ref([]);
const arrayInformesEvoCol = ref([]);
const listarInformesEvo = () => {
    let url = '/evolucioninformes';
    axios.get(url).then((response) => {
        let respuesta = response.data;
        arrayInformesEvo.value = respuesta.datalist;
        arrayInformesEvoCol.value = respuesta.columnas;
    }).catch((error) => {
        console.log(error);
    });
}

const arrayPostit = ref([])
const listarPostit = (type_object = 'collaborator_classroom_course') => {
    let url = '/postit/listar?type_object=' + type_object;
    axios.get(url).then((response) => {
        let respuesta = response.data;
        arrayPostit.value = respuesta.data;
    }).catch((error) => {
        console.log(error);
    });
}

const printPostit = (fk_object = 0, fk_object2 = 0, field = '') => {
    let out = '';
    let arrayResult = [];
    if (fk_object > 0 && fk_object2 > 0 && arrayPostit.value.length > 0) {
        arrayResult = arrayPostit.value.filter(obj => obj.fk_object == fk_object && obj.fk_object2 == fk_object2)
    }

    if (field && arrayResult.length) {
        let myfield = arrayResult[0][field]
        if (myfield) {
            out += myfield
        }
    }

    return out;
}

const textSearch = ref('')
var TRange = null;

const buscarInWeb = (str) => {
    if (parseInt(navigatorVersion.value) < 4) return;
    var strFound;
    if (window.find) {
        strFound = self.find(str);
        if (!strFound) {
            strFound = self.find(str, 0, 1);
            while (self.find(str, 0, 1)) continue;
        }
    }
    else if (navigatorName.value.indexOf("Microsoft") != -1) {
        if (TRange != null) {
            TRange.collapse(false);
            strFound = TRange.findText(str);
            if (strFound) TRange.select();
        }
        if (TRange == null || strFound == 0) {
            TRange = self.document.body.createTextRange();
            strFound = TRange.findText(str);
            if (strFound) TRange.select();
        }
    }
    else if (navigatorName.value == "Opera") {
        alert("Opera browsers not supported, sorry...")
        return;
    }
    if (!strFound) alert("String '" + str + "' not found!")
    return;
}

const formatDate = (datesource, format = 'day') => {
    if (datesource) {
        if (format == 'day') {
            var date = new Date(datesource + 'T00:00:00')
        } else {
            var date = new Date(datesource)
        }

        let result = ''
        if (format == 'day') {
            result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        } else if ((format == 'Y')) {
            result = date.getFullYear()
        } else if (format == 'dayhour') {
            result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        } else if (format == 'hour') {
            result = (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        }

        return result
    }
}

const formEvent = useForm({
    start: '',
    end: '',
    title: '',
    contentFull: ''
})
const arrayEvent = ref([])
const errorEvent = ref('')
const eventUpdateOrCreate = (id = 0) => {
    let ruta = 'event-registrar';
    if (id > 0) {
        ruta = 'event-actualizar';
    }
    if (!formEvent.title || !formEvent.start || !formEvent.end) {
        errorEvent.value = 'Debe ingresar un título y rango de fechas'
    } else {
        errorEvent.value = ''
    }

    if (!errorEvent.value) {
        axios.post(route(ruta), formEvent).then((response) => {
            if (response.data.error) {
                errorEvent.value = response.data.error;
            } else if (response.data.success) {
                Inertia.reload({ only: ['events', 'eventsnow'] })
                onToggle()
                console.log('Evento creado')
            }
        }).catch((error) => {
            console.log(error);
        });
    }
}

const isModalVisible = ref(false)
const onToggle = () => {
    isModalVisible.value = !isModalVisible.value
    const scroll = document.querySelector('body');
    scroll.classList.toggle('overflow-hidden');
}

const loading = ref(false)
const analtycBimestre = ref('')
const analyticCourses = ref([])
const progress = ref(0)
const lowcal = ref(0)
const analizarCalificaciones = async (bimestre = '') => {
    if (bimestre) {
        let url = '/calification/analyticsclassrooms/courses?ref_ciclo=' + bimestre;
        loading.value = true;
        await axios.get(url).then((response) => {
            let respuesta = response.data;
            analyticCourses.value = respuesta.datalist;
            console.log(analyticCourses.value);

            if (!respuesta.success) {
                loading.value = false
            }
            console.log(respuesta.message);
        }).catch((error) => {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
        loading.value = false
    }
}

const calcProgressCalif = (id, type = 'progress', rescolor = 0) => {
    let color = 'red'
    if (analyticCourses.value.length > 0) {
        let objc = analyticCourses.value.find(obj => obj.id === id)
        if (objc && objc.students > 0) {
            if (type == 'progress') {
                if (objc.progress > 0) {
                    if (objc.progress == objc.students) {
                        color = 'green'
                    } else {
                        color = 'yellow'
                    }
                } else {
                    color = 'red'
                }

                if (rescolor) {
                    return color
                }
                return objc.progress
            }
            if (type == 'lownota') {
                if (objc.lownota > 0) {
                    color = 'red'
                }

                if (rescolor) {
                    return color
                }
                return objc.lownota
            }
            if (type == 'students') {
                return objc.students
            }
        }
    }
    return 0;
}
</script>

<template>

    <Head title="Aulas" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader
                title="Aulas Asignadas"
                subtitle="Gestiona tus clases virtuales, asiste alumnos, registra calificaciones y sube recursos."
                icon="tabler:school"
                color="rose"
            >
                <template #bottom>
                    <PremiumTabs 
                        v-model="tab" 
                        :tabs="tabsMenu" 
                        @change="handleTabChange" 
                    />
                </template>
            </PremiumPageHeader>
        </template>

        <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')" hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} {{ selectedEvent.start &&
                selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.format('DD/MM/YYYY') }} {{ selectedEvent.end &&
                    selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal>

        <div class="">
            <template v-if="tab == 0">
                <div class="pb-6">
                    <div class="grid grid-cols-6 gap-6">
                        <div class="col-span-6 lg:col-span-4 card-premium pt-10 pb-4 2xl:pb-10 px-6 bg-no-repeat bg-[url('/img/room/bg.png')] bg-contain bg-top h-full">
                            <div class="flex items-center h-full lg:py-8">
                                <div class="grid grid-cols-1 gap-6 w-full">
                                    <div class="col-span-1">
                                        <div class="flex xl:items-center justify-between gap-3 flex-col sm:flex-row">
                                            <div class="order-2 sm:order-1">
                                                <h5 class="text-slate-800 dark:text-white text-xl font-bold flex items-center gap-2">
                                                    <Icon icon="tabler:calendar-event" class="text-rose-500 w-5 h-5" />
                                                    Agenda del Día
                                                </h5>
                                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
                                                    Cronograma de actividades/eventos
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-span-1">
                                        <ol v-if="eventsnow.length" class="sm:flex list-none w-full">
                                            <li class="relative mb-6 sm:mb-0" v-for="event in eventsnow" :key="event.id">
                                                <div class="flex items-center">
                                                    <div class="flex items-center justify-center w-10 h-10 bg-rose-100 rounded-full ring-0 ring-white dark:bg-rose-900 sm:ring-8 dark:ring-rose-900 shrink-0">
                                                        <Icon icon="tabler:calendar-share" class="text-rose-600 w-5 h-5" />
                                                    </div>
                                                    <div class="hidden sm:flex w-full bg-gray-200 h-0.5 dark:bg-gray-700">
                                                    </div>
                                                </div>
                                                <div class="mt-3 sm:pr-8">
                                                    <div class="text-sm 2xl:text-base font-bold text-slate-800 dark:text-white">
                                                        {{ event.title }}
                                                    </div>
                                                    <time class="block mb-2 text-xs font-semibold leading-none text-slate-400 dark:text-slate-500 mt-1">
                                                        {{ event.start && formatDate(event.start, 'hour') }} - {{
                                                            event.end && formatDate(event.end, 'hour') }}</time>
                                                    <p class="text-xs 2xl:text-sm text-slate-600 dark:text-slate-355 mt-1">
                                                    <div v-html="event.contentFull"></div>
                                                    </p>
                                                </div>
                                            </li>
                                        </ol>
                                        <ol v-else class="sm:flex list-none w-full">
                                            <li class="relative mb-6 sm:mb-0">
                                                <div class="flex items-center">
                                                    <div class="flex items-center justify-center w-10 h-10 bg-rose-100 rounded-full ring-0 ring-white dark:bg-rose-900 sm:ring-8 dark:ring-rose-900 shrink-0">
                                                        <Icon icon="tabler:calendar-off" class="text-rose-600 w-5 h-5" />
                                                    </div>
                                                    <div class="hidden sm:flex w-full bg-gray-200 h-0.5 dark:bg-gray-700">
                                                    </div>
                                                </div>
                                                <div class="mt-3 sm:pr-8">
                                                    <div class="text-sm 2xl:text-base font-semibold text-gray-900 dark:text-white">
                                                        Sin Eventos
                                                    </div>
                                                    <time class="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                                                    </time>
                                                    <p class="text-xs 2xl:text-sm font-normal text-gray-900">
                                                        No tenemos eventos agendados para hoy </p>
                                                </div>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-span-6 lg:col-span-2 card-premium min-h-[390px] flex flex-col justify-between p-6">
                            <div class="block w-full mb-4 h-[calc(100%_-_56px)]">
                                <VueCal :transitions="false" xsmall :time="false" locale="es" hide-view-selector :disable-views="['years', 'year', 'day']" :events="events" class="cal-rose" active-view="month" :on-event-click="onEventClick" />
                            </div>
                            <div>
                                <BaseButton color="danger" :icon="mdiPlus" label="Añadir evento" class="w-full rounded-xl shadow-md hover:shadow-lg transition-all" @click="onToggle" />
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Modal Unens -->
                <Transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
                    <div v-if="isModalVisible">
                        <div class="fixed inset-0 px-2 z-20 overflow-hidden flex items-center justify-center transition-opacity">
                            <div @click="onToggle" class="absolute bg-black opacity-70 inset-0 z-10">
                            </div>
                            <div class="container overflow-hidden z-50">
                                <div class="flex flex-row justify-center">
                                    <div class="basis-12/12 md:basis-10/12 lg:basis-8/12 xl:basis-5/12 bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700/50 rounded-2xl shadow-2xl overflow-hidden">
                                        <div class="flex items-center justify-between p-5 border-b border-slate-100 dark:border-slate-700">
                                            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
                                                Crear Nuevo Evento
                                            </h3>
                                            <button @click="onToggle" type="button" class="text-slate-400 hover:text-slate-600 rounded-xl p-1.5 hover:bg-slate-100 dark:hover:bg-slate-750 transition-colors">
                                                <Icon icon="tabler:x" class="w-5 h-5" />
                                            </button>
                                        </div>
                                        <div class="overflow-y-auto max-h-[450px]">
                                            <div class="grid grid-cols-2 p-5 gap-4">
                                                <div class="col-span-2">
                                                    <p class="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                                                        Puede crear actividades/eventos privados en su agenda.
                                                    </p>
                                                </div>
                                                <span v-if="errorEvent" v-text="errorEvent" class="text-red-500"></span>
                                                <div class="col-span-2">
                                                    <label class="text-sm font-semibold text-slate-700 dark:text-slate-300">Título</label>
                                                    <div class="mt-1.5 w-full">
                                                        <input type="text" v-model="formEvent.title" class="w-full input-premium">
                                                    </div>
                                                </div>
                                                <div class="col-span-2 lg:col-span-1 flex flex-col gap-1.5">
                                                    <label class="text-sm font-semibold text-slate-700 dark:text-slate-350">Inicio</label>
                                                    <input type="datetime-local" v-model="formEvent.start" class="w-full input-premium">
                                                </div>
                                                <div class="col-span-2 lg:col-span-1 flex flex-col gap-1.5">
                                                    <label class="text-sm font-semibold text-slate-700 dark:text-slate-355">Fin</label>
                                                    <input type="datetime-local" v-model="formEvent.end" class="w-full input-premium">
                                                </div>
                                                <div class="col-span-2">
                                                    <label class="text-sm font-semibold text-slate-700 dark:text-slate-300">Descripción (Opcional)</label>
                                                    <div class="mt-1.5">
                                                        <textarea class="w-full input-premium min-h-[90px]" v-model="formEvent.contentFull"></textarea>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="flex items-center justify-end gap-3 p-5 border-t border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40">
                                            <button type="button" class="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors text-sm font-semibold cursor-pointer" @click="onToggle">Cerrar</button>
                                            <button type="button" class="px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white rounded-xl shadow-md hover:shadow-lg transition-all text-sm font-semibold cursor-pointer" @click="eventUpdateOrCreate()">Aceptar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </Transition>

                <!-- Sección maestro -->
                <div class="mt-6">
                    <div class="card-premium p-6">
                        <div class="grid grid-cols-1 gap-3">
                            <div>
                                <h2 class="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
                                    <Icon icon="tabler:notebook" class="text-rose-500 w-5 h-5" />
                                    Cursos asignados ({{ classrooms.length }})
                                </h2>
                            </div>
                            <div class="text-xs text-slate-500 dark:text-slate-400">
                                Como maestro/a usted tiene acceso a estas clases (Aulas - Cursos)
                            </div>
                            <div v-if="classrooms.length">
                                <table class="table-responsive-card">
                                    <thead>
                                        <tr class="lg:block">
                                            <th class="lg:w-20" />
                                            <th class="lg:w-60">Curso - Aula/Sección</th>
                                            <th class="lg:w-60">Nota privada</th>
                                            <th class="w-auto">Sílabo/Documentos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="aula in classrooms" :key="aula.id" class="">
                                            <td class="lg:w-20 tittle" :id="'maestro' + aula.id_course">
                                                <div class="flex w-full items-center lg:justify-center justify-start">
                                                    <Link :href="route('classroomcard-collaborator', { 'id_classroom': aula.id, 'id_course': aula.id_course, 'can_write': 1, 'back_link': 'maestro' + aula.id_course })" class="rounded-xl h-10 w-10 flex items-center justify-center text-white transition-all duration-200 bg-rose-500 hover:bg-rose-600 shadow-md hover:shadow-lg focus:outline-none">
                                                        <Icon icon="tabler:book-2" class="w-5 h-5" />
                                                    </Link>
                                                </div>
                                            </td>
                                            <td data-label="Curso" class="lg:w-60 ">
                                                <Link :href="route('classroomcard-collaborator', { 'id_classroom': aula.id, 'id_course': aula.id_course, 'can_write': 1, 'back_link': 'maestro' + aula.id_course })">
                                                    <p class="font-bold text-slate-800 dark:text-white">
                                                        {{ aula.label_course }}
                                                    </p>
                                                    <p class="text-slate-500 dark:text-slate-400 text-xs mt-0.5">
                                                        <span>{{ aula.ref }} - {{ aula.label }}</span>
                                                        <br>
                                                        {{ aula.label_short_level + ' ' + (aula.secondary_label ?
                                                            aula.secondary_label : (aula.label_short_aula ?
                                                                aula.label_short_aula :
                                                                '?')) }}
                                                    </p>
                                                </Link>
                                            </td>
                                            <td data-label="Nota privada" class="lg:w-60 ">
                                                <p>
                                                    <small class="text-xs text-slate-600 dark:text-slate-355">
                                                        {{ printPostit(aula.id, aula.id_course, 'description') }}
                                                    </small>
                                                </p>
                                            </td>
                                            <td data-label="Sílabo" class="w-auto mt-0-imp">
                                                <div class="order-1 sm:order-2">
                                                    <Link :href="route('documents', { 'id_classroom': aula.id, 'id_course': aula.id_course, 'can_write': 1, 'back_link': 'maestro' + aula.id_course })">
                                                        <button class="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-xs font-semibold shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer" title="Recursos de estudio u otros">
                                                            Documentos
                                                        </button>
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-slate-500 dark:text-slate-400 text-xs py-4">
                                Sin aulas asignadas para la enseñanza de un curso ...
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sección tutor-->
                <div v-if="isTutor" class="mt-6">
                    <div class="card-premium p-6">
                        <div>
                            <div class="mb-4">
                                <h2 class="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
                                    <Icon icon="tabler:users-group" class="text-rose-500 w-5 h-5" />
                                    Aulas del Tutor ({{ classroomsTutor.length }})
                                </h2>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
                                    Como Tutor/a usted tiene acceso a estas aulas con sus clases (Aulas - Cursos).
                                </p>
                            </div>
                            <div v-if="classroomsTutor.length" class="mt-2">
                                <table class="table-responsive-card">
                                    <thead>
                                        <tr class="lg:block">
                                            <th class="lg:min-w-[80px]"></th>
                                            <th class="lg:min-w-[200px]">Aula/Sección</th>
                                            <th class="">Cursos (
                                                <small class="text-red-655 font-semibold">
                                                    Sólo lectura, no crear ni modificar
                                                </small>)
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="aula in classroomsTutor" :key="aula.id">
                                            <td class="lg:min-w-[80px]" :id="'tutor' + aula.id">
                                                <Link :href="route('classroom-collaborator', { 'id_classroom': aula.id, 'can_write': 0, 'back_link': 'tutor' + aula.id })">
                                                    <div class="w-full flex lg:justify-center">
                                                        <div class="rounded-xl h-10 w-10 flex items-center justify-center text-white transition-all duration-200 bg-rose-500 hover:bg-rose-600 shadow-md hover:shadow-lg focus:outline-none">
                                                            <Icon icon="tabler:chalkboard" class="w-5 h-5" />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </td>
                                            <td data-label="Aula/Sección" class="lg:min-w-[200px]">
                                                <Link :href="route('classroom-collaborator', { 'id_classroom': aula.id, 'can_write': 0, 'back_link': 'tutor' + aula.id })">
                                                    <p class="font-semibold text-lg">
                                                        <span class="text-xs">{{ aula.ref }}</span>
                                                        <br>
                                                        <span class="text-xs">{{ aula.label }}</span>
                                                        <br>
                                                        {{ aula.label_short_level + ' ' + (aula.secondary_label ? aula.secondary_label : (aula.label_short_aula ? aula.label_short_aula : '?')) }}
                                                    </p>
                                                </Link>
                                            </td>
                                            <td data-label="Cursos (Sólo lectura)" class="w-full content">
                                                <div class="w-full flex flex-wrap gap-2 lg:pt-0 pt-3">
                                                    <div v-for="curso in getCoursesForLevel(aula.id_level)" :key="curso.id">
                                                        <Link :href="route('classroomcard-collaborator', { 'id_classroom': aula.id, 'id_course': curso.id, 'can_write': 0, 'back_link': 'tutor' + aula.id })" class="px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 rounded-xl text-xs font-semibold shadow-sm transition-all duration-200 inline-block">
                                                            {{ curso.label }}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-slate-500 dark:text-slate-400 text-xs py-4">
                                Si es tutor, falta asignarle sus aulas de Tutoría, consulte con el coordinador ...
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sección coordinador -->
                <div v-if="isAdmin || isCoord" class="mt-6">
                    <!-- LOADING -->
                    <div class="card-premium p-6 relative">
                        <div v-if="loading" class="flex flex-col rounded-2xl justify-center items-center top-0 right-0 left-0 bottom-0 absolute bg-white/80 dark:bg-slate-800/80 z-50">
                            <div class="border-slate-350 h-14 w-14 animate-spin rounded-full border-8 border-t-rose-600" />
                        </div>
                        <div class="grid grid-cols-1 gap-3" :class="loading ? 'pointer-events-none' : ''">
                            <div>
                                <h2 class="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
                                    <Icon icon="tabler:user-cog" class="text-rose-500 w-5 h-5" />
                                    Aulas del Coordinador ({{ classroomsCoord.length }})
                                </h2>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
                                    Como coordinador/a usted tiene acceso a esta lista de clases (Aulas - Cursos).
                                </p>
                            </div>
                            <div v-if="classroomsCoord.length">
                                <div class="pb-3 mt-4">
                                    <div class="flex justify-between gap-4 lg:flex-row flex-col items-start lg:items-center">
                                        <div class="flex items-center gap-2 w-full lg:w-auto">
                                            <span class="text-xs font-semibold text-slate-650 dark:text-slate-350">Buscar:</span>
                                            <input type="text" id="t1" name="t1" v-model="textSearch" class="input-premium py-1 w-full sm:w-60" placeholder="Presiona Enter para buscar..." @keyup.enter="buscarInWeb(textSearch)">
                                        </div>
                                        <div class="flex items-center gap-2 w-full lg:w-auto">
                                            <span class="text-xs font-semibold text-slate-650 dark:text-slate-355">Analizar Calificaciones:</span>
                                            <select v-model="analtycBimestre" class="input-premium py-1 pr-8 bg-white dark:bg-slate-950" @change="analizarCalificaciones(analtycBimestre)">
                                                <option value="" disabled>Escoja el Bimestre</option>
                                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B1'">Primer Bimestre</option>
                                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B2'">Segundo Bimestre</option>
                                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B3'">Tercer Bimestre</option>
                                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR + 'B4'">Cuarto Bimestre</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <table class="table-responsive-card">
                                    <thead>
                                        <tr class="lg:block">
                                            <th class="lg:min-w-[80px]"></th>
                                            <th class="lg:min-w-[200px]">Aula/Sección</th>
                                            <th class="">Cursos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="aula in classroomsCoord" :key="aula.id">
                                            <td class="lg:min-w-[80px]" :id="'coord' + aula.id">
                                                <Link :href="route('classroom-collaborator', { 'id_classroom': aula.id, 'can_write': 1, 'back_link': 'coord' + aula.id })">
                                                    <div class="w-full flex lg:justify-center">
                                                        <div class="rounded-xl h-10 w-10 flex items-center justify-center text-white transition-all duration-200 bg-rose-500 hover:bg-rose-600 shadow-md hover:shadow-lg focus:outline-none">
                                                            <Icon icon="tabler:chalkboard" class="w-5 h-5" />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </td>
                                            <td data-label="Aula/Sección" class="lg:min-w-[200px]">
                                                <Link :href="route('classroom-collaborator', { 'id_classroom': aula.id, 'can_write': 1, 'back_link': 'coord' + aula.id })">
                                                    <p class="font-semibold text-lg">
                                                        <span class="text-xs">{{ aula.ref }}</span>
                                                        <br>
                                                        <span class="text-xs">{{ aula.label }}</span>
                                                        <br>
                                                        {{ aula.label_short_level + ' ' + (aula.secondary_label ? aula.secondary_label : (aula.label_short_aula ? aula.label_short_aula : '?')) }}
                                                    </p>
                                                </Link>
                                            </td>
                                            <td data-label="Cursos" class="w-full content">
                                                <div class="w-full flex flex-wrap gap-2 lg:pt-0 pt-3">
                                                    <div v-for="curso in getCoursesForLevel(aula.id_level)" :key="curso.id" class="relative">
                                                        <Link :href="route('classroomcard-collaborator', { 'id_classroom': aula.id, 'id_course': curso.id, 'can_write': 1, 'back_link': 'coord' + aula.id })" class="px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 rounded-xl text-xs font-semibold shadow-sm transition-all duration-200 inline-block" :class="analtycBimestre ? 'pr-9' : ''">
                                                            {{ curso.label }}

                                                            <div v-if="analtycBimestre" class="absolute right-1 top-1/2 -translate-y-1/2 flex items-center gap-0.5" title="Progreso de calificaciones">
                                                                <span class="text-white text-[9px] font-extrabold h-4 min-w-[16px] px-1 flex items-center justify-center rounded-full shadow-sm" :class="calcProgressCalif(aula.id + '_' + curso.id, 'progress', 1) === 'green' ? 'bg-green-600' : (calcProgressCalif(aula.id + '_' + curso.id, 'progress', 1) === 'yellow' ? 'bg-yellow-500' : 'bg-rose-600')">
                                                                    {{ calcProgressCalif(aula.id + '_' + curso.id, 'progress') }}
                                                                </span>
                                                                <span v-if="calcProgressCalif(aula.id + '_' + curso.id, 'lownota') > 0" class="bg-rose-600 text-white text-[9px] font-extrabold h-4 min-w-[16px] px-1 flex items-center justify-center rounded-full shadow-sm animate-pulse" title="Alumnos con promedio bajo">
                                                                    {{ calcProgressCalif(aula.id + '_' + curso.id, 'lownota') }}
                                                                </span>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-slate-500 dark:text-slate-400 text-xs py-4">
                                Si es coordinador falta establecer el nivel de turno en las aulas, consulte con el administrador del sistema ...
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sección modo lectura (Psicología / Secretaría) -->
                <div v-if="isPsico || isSecre" class="mt-6">
                    <div class="card-premium p-6">
                        <div class="mb-4">
                            <h2 class="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
                                <Icon icon="tabler:eye" class="text-rose-500 w-5 h-5" />
                                Aulas en modo lectura ({{ classroomsCoord.length }})
                            </h2>
                            <div class="alert-premium-info mt-3">
                                <p class="font-semibold flex items-center gap-1.5">
                                    <Icon icon="tabler:info-circle" class="w-4 h-4" /> Aulas en modo lectura para una vista limitada de la información.
                                </p>
                                <p>Si es usuario del área de psicología usted tiene acceso a todas las aulas para el registro de EAP.</p>
                            </div>
                        </div>

                        <div v-if="classroomsCoord.length">
                            <div class="flex items-center gap-2 mb-4">
                                <span class="text-xs font-semibold text-slate-655 dark:text-slate-350">Buscar:</span>
                                <input type="text" id="t1" name="t1" v-model="textSearch" class="input-premium py-1 w-full sm:w-60" placeholder="Presiona Enter para buscar..." @keyup.enter="buscarInWeb(textSearch)">
                            </div>

                            <table class="table-responsive-card">
                                <thead>
                                    <tr class="lg:block">
                                        <th class="lg:min-w-[80px]"></th>
                                        <th class="lg:min-w-[200px]">Aula/Sección</th>
                                        <th class="">Cursos (Lectura)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="aula in classroomsCoord" :key="aula.id">
                                        <td class="lg:min-w-[80px]" :id="'coord' + aula.id">
                                            <Link :href="route('classroom-collaborator', { 'id_classroom': aula.id, 'can_write': 0, 'back_link': 'coord' + aula.id })">
                                                <div class="w-full flex lg:justify-center">
                                                    <div class="rounded-xl h-10 w-10 flex items-center justify-center text-white transition-all duration-200 bg-rose-500 hover:bg-rose-600 shadow-md hover:shadow-lg focus:outline-none">
                                                        <Icon icon="tabler:chalkboard" class="w-5 h-5" />
                                                    </div>
                                                </div>
                                            </Link>
                                        </td>
                                        <td data-label="Aula/Sección" class="lg:min-w-[200px]">
                                            <Link :href="route('classroom-collaborator', { 'id_classroom': aula.id, 'can_write': 0, 'back_link': 'coord' + aula.id })">
                                                <p class="font-semibold text-lg">
                                                    <span class="text-xs">{{ aula.ref }}</span>
                                                    <br>
                                                    <span class="text-xs">{{ aula.label }}</span>
                                                    <br>
                                                    {{ aula.label_short_level + ' ' + (aula.secondary_label ? aula.secondary_label : (aula.label_short_aula ? aula.label_short_aula : '?')) }}
                                                </p>
                                            </Link>
                                        </td>
                                        <td data-label="Cursos" class="w-full content">
                                            <div class="w-full flex flex-wrap gap-2 lg:pt-0 pt-3">
                                                <div v-for="curso in getCoursesForLevel(aula.id_level)" :key="curso.id">
                                                    <Link :href="route('classroomcard-collaborator', { 'id_classroom': aula.id, 'id_course': curso.id, 'can_write': 0, 'back_link': 'coord' + aula.id })" class="px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 rounded-xl text-xs font-semibold shadow-sm transition-all duration-200 inline-block">
                                                        {{ curso.label }}
                                                    </Link>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="text-slate-500 dark:text-slate-400 text-xs py-4">
                            Si es del área de psicología falta establecer el nivel de turno en las aulas, consulte con el administrador del sistema ...
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="tab == 1">

                <div class="card-premium p-6">
                    <div v-if="arrayDiarioCol.length" class="w-full overflow-x-auto">
                        <TableAdvanced modulo="diario" modulos="Diario de asistencia" :data="arrayDiario" :fields="arrayDiarioCol" ruta="diario" exporteable searchAdvance :checkable="(isAdmin || isCoord)" :massDelete="isAdmin" @reload="listarDiario()" />
                    </div>
                    <div v-else class="py-12 flex justify-center">
                        <CardBoxComponentLoad />
                    </div>
                </div>

            </template>

            <template v-else-if="tab == 2">

                <div class="card-premium p-6">
                    <div v-if="arrayCalificationCol.length" class="w-full overflow-x-auto">
                        <TableAdvanced modulo="calification" modulos="Calificaciones" :data="arrayCalification" :fields="arrayCalificationCol" ruta="calification" exporteable searchAdvance :checkable="(isAdmin || isCoord)" :massDelete="isAdmin" changeSelect1 titleSelect1="curso" :select1="arrayCalificationCourses" :isSearchYear="isAdmin" @reload="listarCalification()" vueselectmassaction />
                    </div>
                    <div v-else class="py-12 flex justify-center">
                        <CardBoxComponentLoad />
                    </div>
                </div>

            </template>

            <template v-else-if="tab == 3">

                <div class="card-premium p-6">
                    <div class="alert-premium-info mb-6">
                        <p class="font-semibold flex items-center gap-1.5">
                            <Icon icon="tabler:info-circle" class="w-4 h-4" /> Instrucciones para Puntajes EAP:
                        </p>
                        <ul class="list-disc list-inside space-y-1 mt-2 text-xs">
                            <li>Debe filtrar por <b>nivel y bimestre</b> para el cálculo de puestos y la impresión de diplomas.</li>
                            <li>Los alumnos cuyo acceso a la plataforma esté <b>inactivo (deuda u otro) no se mostrarán</b> en la lista de resultados.</li>
                            <li>Para publicar las notas (los alumnos vean sus notas en su plataforma) debe seleccionarlas y elegir la opción <b>Publicar Puntaje EAP</b> en la acción masiva.</li>
                            <li>En la vista del diploma, presione <b>Ctrl + P</b> para imprimir. Ajuste la orientación a horizontal, márgenes mínimos y active los gráficos de fondo.</li>
                        </ul>
                    </div>

                    <div v-if="arrayAdmisionPuntajeCol.length" class="w-full overflow-x-auto">
                        <TableAdvanced modulo="admisionpuntaje" modulos="Puntajes EAP" :data="arrayAdmisionPuntaje" :fields="arrayAdmisionPuntajeCol" ruta="admisionpuntaje" exporteable searchAdvance :checkable="(isAdmin || isCoord)" :massDelete="isAdmin" showIndex printLine labelprint1="diploma" @reload="listarAdmisionPuntaje()" />
                    </div>
                    <div v-else class="py-12 flex justify-center">
                        <CardBoxComponentLoad />
                    </div>
                </div>

            </template>

            <template v-else-if="tab == 4">

                <div class="card-premium p-6">
                    <div v-if="isAdmin || isCoord" class="alert-premium-info mb-6">
                        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                            <p class="flex items-center gap-1.5">
                                <Icon icon="tabler:info-circle" class="w-4 h-4" /> Los recursos de estudio pasados son reemplazados con los nuevos si tienen el mismo nombre.
                            </p>
                            <div class="flex items-center gap-2" title="Año de creación del archivo">
                                <span class="text-xs font-semibold">Año:</span>
                                <input name="year" class="w-20 input-premium py-1" type="text" v-model="anioSearch" @change="listarFileResources()" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
                            </div>
                        </div>
                    </div>

                    <div v-if="arrayFileResourcesCol.length" class="w-full overflow-x-auto">
                        <TableAdvanced modulo="Documento" modulos="Recursos de estudio" :data="arrayFileResources" :fields="arrayFileResourcesCol" exporteable ruta="file" :checkable="(isAdmin || isCoord)" :massDelete="massDeleteResource" @reload="listarFileResources()" />
                    </div>
                    <div v-else class="py-12 flex justify-center">
                        <CardBoxComponentLoad />
                    </div>
                </div>

            </template>

            <template v-else-if="tab == 5">

                <div class="card-premium p-6">
                    <div v-if="arrayInformesEvoCol.length" class="w-full overflow-x-auto">
                        <TableAdvanced modulo="evolucioninforme" modulos="Informes de evolución" :data="arrayInformesEvo" :fields="arrayInformesEvoCol" exporteable ruta="file" />
                    </div>
                    <div v-else class="py-12 flex justify-center">
                        <CardBoxComponentLoad />
                    </div>
                </div>

            </template>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<style scoped>
.vuecal__event {
    cursor: pointer;
}

.vuecal__event-title {
    font-size: 1.2em;
    font-weight: bold;
    margin: 4px 0 8px;
}

.vuecal__event-time {
    display: inline-block;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.vuecal__event-content {
    font-style: italic;
}
</style>
